// Hakiki brand color palette, extracted from logo
export const hakikiMain = '#CCAB4A'; // Example: Replace with your main logo color
export const hakikiAccent = '#FFF'; // Example: Accent color from logo
export const hakikiText = '#000';

const hakikiColors = {
  main: hakikiMain,
  accent: hakikiAccent,
  text: hakikiText,
};

export default hakikiColors;
